import { Box, Button, Dialog, FormControl, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react'

import { useNavigate } from 'react-router';


function ContratMatrix() {

    const [contrats, setContrats] = useState([]);
     
      const fetchContratMatrix = async () => {
          try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/contrat/matrix`);
            console.log(response)
              setContrats(response.data);
          } catch (error) {
              console.error('Error fetching contrats:', error);
          }
      };
    
      useEffect(() => {
        fetchContratMatrix();
      }, []);
    

const navigate = useNavigate();

const defaultContrat = contrats.find(contrat => contrat.name === "default");

const [openDialog, setOpenDialog] = useState(false);
const [newCompetence, setNewCompetence] = useState({
    categorie: '',
    detail: '',
    niveau: ''
});

const handleDialogOpen = () => setOpenDialog(true);
const handleDialogClose = () => {
    setOpenDialog(false);
    setNewCompetence({ categorie: '', detail: '', niveau: '' });
};

const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCompetence(prev => ({ ...prev, [name]: value }));
};

const handleAddCompetence = async () => {
    if (!defaultContrat) return;
    try {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/contrat/${defaultContrat._id}/competence`, newCompetence);
        fetchContratMatrix();
        handleDialogClose();
    } catch (error) {
        console.error('Erreur lors de l\'ajout de la compétence:', error);
    }
};

return (
    <Box>
        <Typography>Matrice des compétences</Typography>
        <Box>
            <Button
                variant="contained"
                color="primary"
                onClick={handleDialogOpen}
                sx={{ mb: 2 }}
            >
                Ajouter des Compétences
            </Button>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Catégorie</TableCell>
                            <TableCell>Détail</TableCell>
                            <TableCell>Niveau</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {defaultContrat && defaultContrat.competences && defaultContrat.competences.length > 0 ? (
                            defaultContrat.competences.map((comp, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{comp.categorie}</TableCell>
                                    <TableCell>{comp.detail}</TableCell>
                                    <TableCell>{comp.niveau}</TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3}>Aucune compétence trouvée.</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* Dialog for adding competence */}
            <Dialog open={openDialog} onClose={handleDialogClose}>
                <Box sx={{ p: 3, minWidth: 350 }}>
                    <Typography variant="h6" gutterBottom>Ajouter une compétence</Typography>
                     <TextField
                        margin="dense"
                        label="Catégorie"
                        name="categorie"
                        fullWidth
                        value={newCompetence.categorie}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        label="Détail"
                        name="detail"
                        fullWidth
                        value={newCompetence.detail}
                        onChange={handleInputChange}
                    />
                     <FormControl fullWidth margin="dense">
                        <InputLabel id="level-label">Niveau</InputLabel>
                        <Select
                            labelId="level-label"
                            name="level"
                            value={newCompetence.level}
                            label="Niveau"
                            onChange={handleInputChange}
                        >
                            <MenuItem value="Ingénieur">Ingénieur</MenuItem>
                            <MenuItem value="Administrateur">Administrateur</MenuItem>
                            <MenuItem value="Technicien">Technicien</MenuItem>
                        </Select>
                    </FormControl>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                        <Button onClick={handleDialogClose} sx={{ mr: 1 }}>Annuler</Button>
                        <Button variant="contained" onClick={handleAddCompetence}>Ajouter</Button>
                    </Box>
                </Box>
            </Dialog>
        </Box>
    </Box>
)
}

export default ContratMatrix